import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '@components/Button/Button';
import styles from './ModalConfirmCloseEdit.module.scss';

interface ModalConfirmCloseEditProps {
    handleCancel: () => void;
    handleAccept: () => void;
    modalWidth?: string;
}

const ModalConfirmCloseEdit: React.FC<ModalConfirmCloseEditProps> = ({ modalWidth, handleAccept, handleCancel }) => {
    return (
        <Modal show onHide={handleCancel} centered dialogClassName={modalWidth || ''}>
            <div className="modalCustom">
                <h3 className='text-center'>¿Seguro que desea salir?</h3>

                <p className='text-center'>Al salir, no se guardarán los cambios realizados.</p>

                <div className={`modalCustom-buttons ${styles.buttons}`}>
                    <Button
                        label="Cancelar"
                        type="secondary"
                        icon="close"
                        iconPosition="left"
                        handleClick={handleCancel}
                    />
                    <Button
                        label="Aceptar"
                        icon="check-8"
                        iconPosition="left"
                        status='success'
                        handleClick={handleAccept}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default ModalConfirmCloseEdit;
